import { HTTP, Routes, snakeKeys } from 'vue_features/shared/helpers/http_helper'

export default {
  update(user) {
    return HTTP.put(Routes.user_path(), snakeKeys({ user }))
  },
}
